import { createAction, props } from '@ngrx/store';

export const seHeaderToolbarSetIsNavigateOnClickEnabled = createAction(
    '[SeHeaderToolbar] SetIsNavigateOnClickEnabled',
    props<{ enable: boolean }>(),
);
